// TODO - use environment variable for this in production
export const API_BASE_URL = "";
export const apiStatuses = {
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
  RESTING: "resting",
};
